import { produce, Draft } from 'immer';
import { ADMIN_USER, LOGIN_USER, LOGOUT_USER } from '../actions';
import { AuthModel, AuthModelActions } from '../mappers/AuthTypesMapper';

export const initialAuthState: AuthModel = {
  token: '',
  isAdmin: false,
  isAuthenticated: false,
};

export const authReducer = produce((state: Draft<AuthModel>, action: AuthModelActions) => {
  switch (action.type) {
    case LOGOUT_USER:
      state.token = '';
      state.isAdmin = false;
      state.isAuthenticated = false;
      break;
    case LOGIN_USER:
      state.token = action.payload?.token || '';
      state.isAuthenticated = true;
      break;
    case ADMIN_USER:
      state.isAdmin = action.payload?.isAdmin || false;
      state.isAuthenticated = true;
      break;
    default:
      break;
  }
}, initialAuthState);
